import React, { useEffect, useState } from 'react';
import { beer } from '../../models/beer';
import BeerElement from './BeerElement';
import { capitalize } from '@mui/material';

export interface BeerListProps {
    beers: beer[] | undefined;
}
function BeerList(props: BeerListProps) {
    const [groupdBeers, setGroupedBeers] = useState<[string, beer[]][]>([]);

    useEffect(() => {
        if (!!props.beers) {
            var birrifici: any[] = [];
            var grouped = props.beers.reduce(function (r, a) {
                r[a.birrificio] = r[a.birrificio] || [];
                if (!birrifici.includes(a.birrificio))
                    birrifici.push(a.birrificio);
                r[a.birrificio].push(a);
                return r;
            }, Object.create(null));

            var recordList: [string, beer[]][] = [];
            birrifici.forEach(element => {
                if (!!element) {
                    var rcd: [string, beer[]] = [element, grouped[element]];
                    recordList.push(rcd);
                }
            });
            setGroupedBeers(recordList)
        }
    }, [])

    return (
        <div>
            <div className='menu-title'>Carta delle Birre</div>
            <div className='menu-content'>
                {
                    groupdBeers.map(_ =>
                        <>
                            <div className='menu-title-small'>{capitalize(_[0].toLowerCase())}</div>
                            <div>{_[1].map(b => <BeerElement beer={b} />) }</div>
                        </>
                    )
                }
            </div>
        </div>

    );
}

export default BeerList;